import { render, staticRenderFns } from "./purchase_bill_detail.vue?vue&type=template&id=028d69a1&scoped=true"
import script from "./purchase_bill_detail.vue?vue&type=script&lang=js"
export * from "./purchase_bill_detail.vue?vue&type=script&lang=js"
import style0 from "./purchase_bill_detail.vue?vue&type=style&index=0&id=028d69a1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028d69a1",
  null
  
)

export default component.exports